import React from 'react';

const BuildComponent = () => {
  return (
    <div className="sidebar-container help-sidebar">
      <p className="light-grey-text">HELP</p>
      <h1 className="title">What did you build?</h1>
      <p className="alt-text">Try to answer these key questions:</p>
      <ul className="categoried-list">
        <li>What was the purpose and functionality of the project?</li>
        <li>What was your role in the team and who did you collaborate with?</li>
        <li>What languages, frameworks, tools, and/or databases did you use?</li>
      </ul>
      <h1 className="sub-title">Example</h1>
      <div className="panel">
        <p className="sub-title">What did you build?</p>
        <p className="alt-text">Ticket management system.</p>
        <p className="description">Led a team of 6 engineers in building a SaaS ticket management system (similar to JIRA) for taskfy.com</p>
        <p className="description">Developed Web API backend using Node.js, Typescript, Express.js, TypeORM, and JWT for user authentication. Used MySQL for data storage</p>
        <p className="description">Implemented Elasticsearch for indexing ticket data.</p>
        <p className="description">Developed front end using Typescript, React.js, Redux, Redux Saga, Ant Design. Set up unit tests with Jest, React testing framework, Cypress.</p>
        <p className="description">Created CI/CD pipelines using Jenkins.</p>
        <p className="description">Used GCP for hosting</p>
        <p className="description">Setup Kubemetes cluster for auto scaling and fault tolerance.</p>
        <p className="description">Integrated with Twillio for email and SMS notifications.</p>
      </div>
    </div>
  );
};

export default BuildComponent;
